import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  IconButton,
  Toolbar,
  SvgIcon,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Menu as MenuIcon } from 'lucide-react';
import { THEMES } from 'src/constants';
import Logo from 'src/components/Logo';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    ...(theme.name === THEMES.LIGHT ? {
      boxShadow: 'none',
      background: theme.palette.primary.main
    } : {}),
    ...(theme.name === THEMES.ONE_DARK ? {
      background: theme.palette.background.default
    } : {})
  },
  metalRoot: {
    backgroundColor: "var(--neutral-1)",
    boxShadow: 'none',
    paddingRight: 0,
    width: theme.breakpoints.down('md') ? "100%" : 230,
    left: 0,
    right: "unset"
  },
  toolbar: {
    height: 64
  },
  listBox: {
    background: theme.palette.background.default
  },
  metalHeader: {
    paddingLeft: "0 !important",
    backgroundColor: 'var(--neutral-1)',
    boxShadow: "none",
    paddingRight: `${theme.spacing(2)} !important`
  },
  metalBackground: {
    backgroundColor: "var(--neutral-2)"
  },
  metalLogo: {
    width: "50%",
    minWidth: "150px",
    height: "40px",
    marginLeft: '16px'
  },
}));

const TopBar = (props) => {
  const { className, onMobileNavOpen } = props 
  const theme = useTheme()
  const { t }  = useTranslation();
  const { classes, cx } = useStyles();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar
      enableColorOnDark
      className={cx(classes.metalRoot, className)}
      style={mobileDevice ? {} : {width: "230px"}}
    >
      <Toolbar 
        className={cx(classes.metalHeader)} 
        style={{ paddingLeft: 0 }}>
          { mobileDevice ? <>
            <IconButton color="textPrimary" onClick={onMobileNavOpen} size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
            </IconButton> </> : (<>
            <RouterLink style={{
              minWidth: "230px",
              width: "230px",
              borderRight: "1px solid #303432",
              borderBottom: "1px solid #303432",
              height: "74px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "var(--neutral-2)"
            }} to={{pathname: "dashboard", search: window.location.search }}>
              <Logo className={classes.metalLogo}/>
            </RouterLink>
            </>)
          }        
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default TopBar;
